import { useCallback } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import { adminLogoutAPI } from "../api/auth";

const useLogout = () => {
  const navigate = useNavigate();
  /** Stable reference so effects that list `logout` in deps do not re-run every render. */
  const logoutAction = useCallback((msg) => {
    // Best-effort API logout; always clear local session.
    try {
      adminLogoutAPI({}).catch(() => {});
    } catch {
      // ignore
    }
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userDetail");
    // keep other localStorage keys intact (theme etc.)
    if (msg) toast.error(msg);
    navigate("/auth-login");
  }, [navigate]);

  return logoutAction;
};

export default useLogout;